import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getBillingInfoSlice = createSlice({
  name: "getBillingInfo",
  initialState,
  reducers: {
    getTravelBillingInfoStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getTravelBillingInfoSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getTravelBillingInfoFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getTravelBillingInfoStart,
  getTravelBillingInfoSuccess,
  getTravelBillingInfoFailure,
  clearError,
  clearMessage,
} = getBillingInfoSlice.actions;

export default getBillingInfoSlice.reducer;
